import { CookieStorage } from "cookie-storage";

enum CookiesKeys {
  TokenKey = "tokenKey"
}
export const cookieStorage = new CookieStorage({
  domain: process.env.REACT_APP_DOMAIN_COOKIE,
  path: "/"
});

export const cookieAvailable = (cookieKey: string, cookieValue: string) => {
  return cookieStorage.getItem(cookieKey) === cookieValue;
};

export default CookiesKeys;
